import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { withStyles } from '@material-ui/core/styles';
import {
    Typography, createStyles, WithStyles, Button, Tabs, Grid, Tab, DialogContent
} from '@material-ui/core';
import { MyPATDialog } from '../../../../common';
// import { createNotesQuestionSchema } from '../validations/validation';



const styles = (theme: Theme) => createStyles({
  root: {
        color: theme.palette.text.primary,
      },
      icon: {
        margin: theme.spacing.unit,
        fontSize: 90,
      },
      iconAlign:{
        display: 'flex',
        justifyContent: 'center', 
        alignText: 'center'
      }

});

interface DeletePopUpProps extends WithStyles<typeof styles> {
    openDialog: any,
    deleteFunction: any,
    handleClose: any,
    classes: any,
    deleteText: string,
    deleteTitle: string

}
interface DeletePopUpState {
    open: boolean,
}


class DeletePopUp extends Component<DeletePopUpProps, DeletePopUpState> {
    constructor(props: DeletePopUpProps) {
        super(props);
        this.state = {
            open: false
        }
    }

    render = () => {
        const { openDialog, deleteText, handleClose, deleteTitle } = this.props;
        return (
            <div>
                <MyPATDialog
                    dialogOpen={openDialog}
                    isAlignCenter={true}
                    isCustomBackground={false}
                    isborderDialogAction={true}
                    otherDialogProps={{
                        fullWidth: true,
                        maxWidth: 'sm',
                    }}
                    customDialogActions={
                        <>
                        <Button
                             color="primary"
                            onClick={this.props.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="contained" color="primary"onClick={this.props.deleteFunction}>Yes, Delete</Button>
                        
                        </>
                    }
                    >
                        <Grid style={{textAlign: 'center'}}>
                            <img alt="deletec icon" src="/assets/svg/learn/deleteQuestLearnNote.svg" />
                        </Grid>
                        <Typography style={{textAlign: 'center', fontSize: '24px',fontWeight: 600, color: '#333',  padding: '20px 0',}}>
                            {deleteTitle ? deleteTitle : 'Delete Page'}
                        </Typography>
                        <Typography variant="body1" style={{textAlign: 'center', fontSize: '16px', color: '#666'}}>
                            {deleteText ? deleteText : 'Are you sure you want to delete this page'} ?
                        </Typography>
                    </MyPATDialog>
                    {/* <Dialog
                    open={openDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" style={{textAlign:'center',}}>
                            <img alt="deletec icon" src="/assets/svg/learn/deleteQuestLearnNote.svg" />
                            <b style={{display: 'block', textAlign: 'center', fontSize: '20px', padding: '20px 0',}}>{deleteTitle ? deleteTitle : 'Delete Page'}</b>
                            <p style={{display: 'block', textAlign: 'center',}}>{deleteText ? deleteText : 'Are you sure you want to delete this page'} ?</p>
               </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={this.props.handleClose} color="primary">
                            Cancel
              </Button>
                <Button
                variant="contained"
                color="primary"
                onClick={this.props.deleteFunction}
                >Yes, Delete
                </Button>

                    </DialogActions>
                </Dialog> */}
            </div>
        );

    }
}



// @ts-ignore
export default withStyles(styles)(DeletePopUp);